<template>
    <div class="container-guest p-2-5 d-flex flex-column align-items-center">
        <!--<img class="img-logo img-size2" src="@/assets/images/logo.svg">-->
        <div class="back-btn-group " @click="goBack">
            <img class="green-back-btn img-size2" src="@/assets/images/ic_green_arrow.svg">
        </div>
        <h4 class="title font-weight-medium ">Sign Up</h4>

        <form class="w-100 form-fnc" autocomplete="off">
            <div class="input-group">
                <img class="img-icon" src="@/assets/images/ic_sign_up_promo_code.svg">
                <input type="text" class="form-control" placeholder="Promo Code" v-model="promotion" @blur="checkPromotion"
                    v-bind:class="{ 'is-invalid' : isPromoValid === false}">
                <div class="invalid-feedback" v-if="!isPromoValid">Invalid Promo</div>
                <div class="valid" v-if="isPromoValid">Promo Code Verified</div>
            </div>
            <label class="sub-title">User & Login Info</label>
            <div class="input-group" style="margin-bottom: 20px">
                <img class="img-icon" src="@/assets/images/ic_sign_up_username.svg">
                <input type="text" class="form-control" placeholder="Name" v-model="first_name"
                       v-bind:class="{ 'is-invalid': attemptSubmit && missingName}">
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id === 'first_name'">{{ error.text }}</div>
            </div>

            <div class="input-group">
                <img class="img-icon" src="@/assets/images/ic_sign_up_mobile.svg">
                <input type="text" class="form-control" placeholder="Mobile No." v-model="phone_no"
                       v-bind:class="{ 'is-invalid': attemptSubmit && missingPhone}">
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id === 'phone_no'">{{ error.text }}</div>
            </div>

            <div class="input-group" style="margin-bottom: 20px;">
                <img class="img-icon" src="@/assets/images/au-icon-email.svg">
                <input type="email" class="form-control input-email" placeholder="Email" v-model="email"
                       v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }"
                       v-if="is_email_valid">
                <input type="email" class="form-control" placeholder="Email" v-model="email"
                       v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }"
                       v-else>
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
            </div>

            <div class="input-group">
                <img class="img-icon" src="@/assets/images/au-icon-password.svg">
                <input type="password" class="form-control" placeholder="Password" v-model="password"
                       v-bind:class="{ 'is-invalid': attemptSubmit && (missingPassword || invalidPasswordLength) }">
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'password'">{{ error.text }}</div>
            </div>

            <label class="sub-title">Business Info</label>
            <div class="input-group">
                <img class="img-icon img-icon-bussiness-card" src="@/assets/images/au-icon-business-name.svg">
                <input type="text" class="form-control" placeholder="Business Name" required v-model="business_name"
                       v-bind:class="{ 'is-invalid': attemptSubmit && missingBusinessName }">
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'business_name'">{{ error.text }}</div>
            </div>

            <div class="input-group">
                <img class="img-icon img-icon-bussiness-country" src="@/assets/images/au-icon-business-country.svg">
                <select @change="setCurrencyId(country_id)" :disabled="isPromoValid" class="custom-select mr-sm-2" v-model="country_id" v-bind:class="{ 'is-invalid': attemptSubmit && missingCountryID }">
                    <option value="null" disabled>Select business country</option>
                    <option v-for="country in bCountries" :value="country.id" :key="country.id">{{ country.name }}</option>
                </select>
                <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'country_id'">{{ error.text }}</div>
            </div>

            <label class="sub-title">Subscription Info</label>
            <div class="input-group">
                <label v-if="country_id === 135" class="checkbox-container">I agree to the
                    <a href="https://financio.co/malaysia/terms-of-service/" target="_blank" class="text-green" >Terms of Service</a> &
                    <a href="https://financio.co/malaysia/privacy-policy/" target="_blank" class="text-green" >Privacy Policy</a>.
                    <input type="checkbox" v-model="agree">
                    <span class="checkmark"></span>
                </label>

                <label v-else-if="country_id === 200" class="checkbox-container">I agree to the
                    <a href="https://financio.co/singapore/terms-of-service/" target="_blank" class="text-green" >Terms of Service</a> &
                    <a href="https://financio.co/singapore/privacy-policy/" target="_blank" class="text-green" >Privacy Policy</a>.
                    <input type="checkbox" v-model="agree">
                    <span class="checkmark"></span>
                </label>

                <label v-else class="checkbox-container">I agree to the
                    <a href="https://financio.co/global/terms-of-service/" target="_blank" class="text-green" >Terms of Service</a> &
                    <a href="https://financio.co/global/privacy-policy/" target="_blank" class="text-green" >Privacy Policy</a>.
                    <input type="checkbox" v-model="agree">
                    <span class="checkmark"></span>
                </label>
                <label style="font-size: 13px" v-if="agree">Your 30-day free trial of Premium subscription will commence today</label>
            </div>

            <div>
                <b-modal ref="my-modal" id="modal-center" centered title="Subscription & Payment Info"
                         hide-footer v-model="showDialog">
                    <p>Subscription Plan : <strong>{{ planName }}</strong> </p>
                    <p class="my-4">You will be first charged at discounted rate <strong>{{ planCurrency }} {{promoData.fee_annual | currency}}</strong></p>
                    <div class="my-4 form-fnc">
                        <div id="dropin-container"></div>
                    </div>
                    <p class="my-4">Payment processed by <a target="_blank" href="https://www.braintreepayments.com/"> Braintree </a>, a PayPal company.  No sensitive information is stored with Financio.</p>
                    <button class="btn btn-block btn-fnc" @submit="submitForm">Proceed</button>
                </b-modal>
            </div>
            <vue-recaptcha ref="recaptcha"
                           @verify="onCaptchaVerified"
                            sitekey="6LeXzqkUAAAAACT8zOC1S7Y8H9u-DWzxbCfn_A9_" :loadRecaptchaScript="true"></vue-recaptcha>
            <button type="submit" @click="validateForm" class="btn btn-block btn-fnc" v-if="agree && recapthaToken != null">SIGN UP</button>
            <flash-message transitionIn="animated swing"></flash-message>
        </form>

        <div class="plainText">Already have an account?
            <b-link :to="{ name: 'login' }" class="link-small">
                <a class="one text-green" href="#" >Login</a>
            </b-link>
        </div>

    </div>
</template>

<script>

    import cryptojs from 'crypto-js';
    import VueRecaptcha from 'vue-recaptcha';
    import authService from "../../services/authService";

    export default {
        components: { VueRecaptcha },
        data: function() {
            return {
                agree: false,
                errors: [],
                bCountries: [],
                bLanguages: [],
                bCurrencies: [],
                email: null,
                password: null,
                country_id: null,
                business_name: null,
                currency_id: null,
                sic_code: 2,
                attemptSubmit: false,
                client_id: cryptojs.MD5(Math.random()).toString(),
                is_email_valid: false,
                first_name: null,
                phone_no: null,
                promotion: null,
                isPromoValid: null,
                token: null,
                showDialog: false,
                checkout: null,
                promoData : {},
                planCurrency: null,
                planName: null,
                nonce: null,
                formData: {},
                recapthaToken : null
            };
        },
        computed: {
            missingEmail: function () {
                if (!this.email) {this.is_email_valid = false;return true;} else {this.is_email_valid = true;return false;}
            },
            invalidEmailFormat: function () {
                if (!this.validEmail(this.email)) { this.is_email_valid = false; return true; } else { this.is_email_valid = true; return false; }
            },
            missingPassword: function () {
                if (!this.password) { return true; } else { return false; }
            },
            invalidPasswordLength: function () {
                if (this.password.length<4) { return true; } else { return false; }
            },
            missingCountryID: function () {
                if (!this.country_id) { return true; } else { return false; }
            },
            missingBusinessName: function () {
                if (!this.business_name) { return true; } else { return false; }
            },
            missingName () {
                if (!this.first_name) { return true; } else { return false; }
            },
            missingPhone () {
                if (!this.phone_no) { return true; } else { return false; }
            }
        },
        methods: {
            setCurrencyId(countryId) {
                console.log(countryId);
                for(var i = 0; i<this.bCurrencies.length; i++) {
                    if(this.bCurrencies[i].country_id == countryId) {
                        this.currency_id = this.bCurrencies[i].id;
                        console.log(this.currency_id)
                    }
                }
            },
            destroyBraintree () {
                if (this.checkout != null) {
                    this.checkout.teardown(function () {
                        this.checkout = null;
                    });
                }
            },
            processPromotion(promotion) {
                this.promoData = promotion;
                this.country_id = promotion.country.id;
                this.planCurrency = promotion.country.currency.symbol;
                this.planName = promotion.plan.name + ' - Monthly Renewal'
                if (promotion.fee_annual) {
                    this.planName = promotion.plan.name + ' - Annual Renewal'
                }
            },
            checkPromotion () {
                console.log("Check Promotions");
                this.destroyBraintree();
                this.isPromoValid = null;
                if (this.promotion.length > 0) {
                    this.axios.get('promotions/' + this.promotion)
                        .then( res => {
                            this.processPromotion(res.data.promotion);
                            this.isPromoValid = true;
                            this.axios.get('braintree/client_token?country_id=' + res.data.promotion.country.id)
                                .then( resBT => {
                                    this.token = resBT.data.client_token;
                                    braintree.setup(this.token, 'dropin', {
                                        container: 'dropin-container',
                                        onReady: function(integration) {
                                            this.checkout = integration;
                                            //$scope.braintreeReady = true;
                                        },
                                        onPaymentMethodReceived: (data) =>  {
                                            this.formData.payment_method_nonce = data.nonce;
                                            this.formData.promotion_code = this.promoData.code;
                                            this.submitForm()
                                        },
                                        onError: function(data) {
                                            console.log(data)
                                        }
                                    });
                                })
                        })
                        .catch(error => {
                            this.isPromoValid = false;
                            this.$root.$emit('show-loading', false);
                            this.$generalAPIErrorHandling(error, this.$router);
                        })
                }
            },
            goBack() {
                window.history.length > 1 ?
                    this.$router.go(-1) :
                    this.$router.push('/login')
            },
            onCaptchaVerified: function (recaptchaToken) {
                const self = this;
                self.status = "submitting";
                // self.$refs.recaptcha.reset();
                this.recapthaToken = recaptchaToken;



            },
            submitForm() {
                console.log(this.formData);
                this.$root.$emit('show-loading', true);
                this.formData = {
                    email: this.email,
                    password: this.password,
                    language_id: 1,
                    country_id: this.country_id,
                    name: this.business_name,
                    currency_id: this.getCurrencyId(this.country_id),
                    phone_no : this.phone_no,
                    first_name: this.first_name,
                    'g-recaptcha-response': this.recapthaToken
                };
                authService.register(this.formData)

            },
            validateForm: function (event) {
                this.errors = [];
                this.attemptSubmit = true;

                if (this.missingEmail) {
                    this.errors.push({id: 'email', text: "This field is compulsory"});
                }
                else if (this.invalidEmailFormat) {
                    this.errors.push({id: 'email', text: 'Valid email required.'});
                }

                if (this.missingPassword) {
                    this.errors.push({id: 'password', text: "This field is compulsory"});
                }
                else if (this.invalidPasswordLength) {
                    this.errors.push({id: 'password', text: "Password has to be more than 4 characters"});
                }

                if (this.missingCountryID) {
                    this.errors.push({id: 'country_id', text: "This field is compulsory"});
                }

                if (this.missingBusinessName) {
                    this.errors.push({id: 'business_name', text: "This field is compulsory"});
                }

                if(this.missingName) {
                    this.errors.push({id: 'first_name', text: "This field is compulsory"});
                }

                if(this.missingPhone) {
                    this.errors.push({id: 'phone_no', text: "Mobile No. is required"});
                }

                if(!this.errors.length) {
                    event.preventDefault();
                    if (this.isPromoValid) {
                        this.showDialog = true;
                    } else {
                        this.submitForm();
                    }

                } else {
                    event.preventDefault();
                }

            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            getCurrencyId: function(country_id) {
                for(var i = 0; i<this.bCurrencies.length; i++) {
                    if(this.bCurrencies[i].country_id == country_id) {
                        let found_id = this.currency_id = this.bCurrencies[i].id;
                        console.log(found_id);
                        return found_id;
                    }
                }
            }
        },
        mounted() {
            this.$root.$emit('show-loading', true);
            this.axios
                .get("/pre_sign_up")
                .then(response => {
                    this.$root.$emit('show-loading', false);
                    this.bCurrencies = response.data.currencies;
                    this.bCountries = response.data.countries;
                    this.bLanguages = response.data.languages;
                    this.bBusinessTypes = response.data.business_types;

                })
                .catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                });
        }
    };
</script>
